<template>
    <div class="bg" :style="{
        'background': `url(${config.bgImageUrl}) no-repeat center/cover`,
        'backgroundColor': '#f5f5f5' // 添加备用背景色
    }">
        <div class="logo_wrap ">
            <img class="logo" :src="config.logoTopImg" alt="" :style="{ 'height': config.logoTopHeight + 'px' }">
            <div class="logo_right">
                <div class="power">{{ $t('PoweredbyMVGX') }}</div>
                <!-- <div class="right_top_txt_shu">|</div>
                <Kefu :sn="sn"></Kefu> -->
            </div>
        </div>
        <div class="content m_rl_20">
            <div class="content_title">
                <img src="../assets/img/seccess_1.png" alt="" class="error">

            </div>
            <div class="content_con">
                <!--  -->
                <!--  -->
                <!-- <p>Thank you for your green action! MVGX will offset the carbon emissions generatedfrom your trip to help the event achieve it slow-carbon goals.</p> -->
                <!-- <p>{{ $t('Thankyoufor') }}</p> -->
                <p style="margin: 20px 0;">{{ $t('Yourinputhelps1') }}</p>
                <!-- <p>{{ $t('Together') }}</p> -->
                <!-- <p> Thank you for your efforts in neutralizing your carbon footprint! </p>
                <p class="mg_top">Our Earth needs your help!</p> -->
                <!-- <p  style="margin-bottom:1.25rem">Thank You For Your Effort To Neutralize Your Carbon Footprint !</p>
                <span >Our Earth Needs Your Help ! </span> -->
            </div>

        </div>
        <div class=" please">
            <!-- Please visit 
            <a href="https://www.mvgx.com/">https://www.mvgx.com/ </a>
            for more information about our products and services. -->
        </div>
        <div class="m_rl_20">
            <!-- <a href="https://www.mvgx.com/"> -->
            <!-- <el-button class="btn" @click="close()">Close</el-button> -->
            <!-- </a> -->
        </div>

    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》'
import Kefu from '@/components/kefu.vue'
import cnt from "@/api/cnt";
export default {
    name: 'carsuccess',
    // import引入的组件需要注入到对象中才能使用
    components: { Kefu },
    data() {
        // 这里存放数据
        return {
            sn: '',
            config: '',
        }
    },
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.sn = this.$route.query.sn;
        this.config = JSON.parse(sessionStorage.getItem('configData')) || ''
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        //   this.getUserEvent(1,1)
    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
    // 方法集合
    methods: {
        //用户行为分析
        getUserEvent(val, type) {
            let ip = localStorage.getItem('Ip')
            let ua = localStorage.getItem('Ua')
            let params = {
                event: val,
                eventType: type,
                userAgent: ua + '=' + ip,
            }
            cnt.getUserEvent(res => {
                console.log(res)
            }, params)
        },
        close() {
            window.opener = null;
            window.open("about:blank", "_top").close()
        },
    }
}
</script>

<style lang='less' scoped>
//@import url(); 引入公共css类
a {
    color: #ffffff;
    text-decoration: none;
}

.bg {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    min-height: 100%;
    // background: url('../assets/img/bj.png') no-repeat;
    background-repeat: no-repeat;
    // position: relative;
    background-size: 100% 100%;
}

.logo {
    width: auto;
}

.logo_wrap {
    padding: 40px 20px;
    display: flex;
    justify-content: space-between;
    align-content: center;

    .logo {
        width: auto;
    }

    .logo_right {
        display: flex;
        align-items: center;
    }

    .right_top_txt_shu {
        margin: 0 12px;
        color: #EDFFFE;
    }

    .power {
        font-size: .75rem;
        font-family: Century Gothic;
        color: #EDFFFE;
    }
}

.right_top_box {
    position: absolute;
    display: flex;
    align-items: center;
    top: 38px;
    right: 20px;

    .right_top_txt {
        font-size: 12px;
        font-family: Century Gothic;
        color: #EDFFFE;
    }

    .right_top_txt_shu {
        margin: 0 12px;
        color: #EDFFFE;
    }

    .bangzhu {
        width: 17px;
        height: 17px;
    }
}

.content {
    background-color: rgba(255, 255, 255, 0.13);
    backdrop-filter: blur(.3125rem);
    padding: 3.0625rem 0;
    text-align: center;
    color: #fff;
    border-radius: 1.25rem;
}

.error {
    width: 3.375rem;
    height: 3.375rem;
    margin-bottom: 2.0625rem;

}

.content_con {
    margin: 0 1.25rem;
    font-size: .9375rem;
    font-family: Century Gothic;
}

.mg_top {
    margin-top: 20px;
}

.please {
    margin: 3.75rem 1.25rem 7.25rem;
    font-size: .8125rem;
    font-family: Century Gothic;
    color: #FFFFFF;
    text-align: center;

}

.please>span {
    font-weight: bold;
}

.btn {
    width: 100%;
    height: 2.8125rem;
    color: #4D94A0;
    margin-bottom: 1.3125rem;
    border-radius: .625rem;
    font-size: .9375rem;
    font-family: Century Gothic;
    box-shadow: 0px 5px 12px 0px rgba(0, 98, 76, 0.22);
}
</style>
